var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/turnovertype-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-1022abab!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/turnovertype-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TurnoverTypeEdit.vue
// module id = 723
// module chunks = 1